import { generateQuery } from 'helpers/utis';

export const AuthApi = {
  loginApi: {
    api: '/auth/login',
    baseURL: 'user',
    method: 'post',
    cancelLogout: true,
    cancelErrorToast: true
  },
  verifyOTPApi: {
    api: '/auth/2FactorAuth',
    baseURL: 'user',
    method: 'post',
    cancelLogout: true
  },
  sendOTPApi: {
    api: '/auth/2fa/resendOtp',
    baseURL: 'user',
    method: 'post'
  },
  ssoLoginApi: {
    api: '/login-url',
    baseURL: 'user',
    method: 'get'
  },
  ssoExchangeApi: {
    api: '/auth/sso/exchange',
    baseURL: 'user',
    method: 'post',
    cancelLogout: true
  },
  forceResetSendOTPApi: {
    api: '/auth/force-reset-password/send-otp',
    baseURL: 'admin',
    method: 'post',
    cancelLogout: true,
    cancelToast: false,
    cancelErrorToast: true
  },
  forceResetPasswordApi: {
    api: '/auth/force-reset-password',
    baseURL: 'admin',
    method: 'post',
    cancelLogout: true,
    cancelToast: false,
    cancelErrorToast: true
  }
};

export const preEligibilityLeadsApi = {
  // api/leads?order=ASC&page=1&take=10' \
  getManageProductApi: {
    url: '/leads',
    method: 'get',
    baseURL: 'manageCAD',
    cancelToast: false,
    query: {
      leadStatus: '',
      isBrePassed: '',
      productId: '',
      partnerId: '',
      mobile: '',
      applicantName: '',
      page: 1,
      take: 10,
      order: 'ASC'
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // https://unnatimobilebackend-uat.azurewebsites.net/api/leads/355
  getPreEligibilityleadsbyIdApi: {
    url: '/leads/',
    method: 'get',
    baseURL: 'manageCAD',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  // /api/leads/pre-eligibility/handle-deviation-decision
  handleDeviationDecisionApi: {
    api: '/leads/pre-eligibility/handle-deviation-decision',
    method: 'post',
    baseURL: 'manageCAD',
    cancelToast: false
  }
};

export const copApiLogsApi = {
  getCopApiLogsApi: {
    url: '/cop-api-logs',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: { applicationId: '' },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getCopApiLogDetailsApi: {
    url: '/cop-api-log-details',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: { apiLogId: '' },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const yubiColendingApi = {
  getYubiApplicationDetailsApi: {
    url: '/al/v1/credit-orchestration-platform/yubi-applicatio-details',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    query: { clientApplicationId: '' },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const manageProductApi = {
  getManageProductApi: {
    url: '/admin/products',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      status: '',
      type: '',
      name: '',
      partnerId: '',
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createManageProductApi: {
    api: '/admin/products',
    baseURL: 'admin',
    method: 'post'
  },
  getManageProductByIdApi: {
    url: '/admin/products/',
    method: 'get',
    baseURL: 'user',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  updateManageProductByIdApi: {
    url: '/admin/products/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  deleteManageProductByIdApi: {
    url: '/admin/products/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getAdminRules: {
    url: '/admin/rules',
    query: {
      type: '',
      entityId: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'user',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  attachRules: {
    url: '/admin/rules',
    query: {
      type: '',
      entityId: ''
    },
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  modifyAdminRules: {
    url: '/admin/rules',
    method: 'put',
    baseURL: 'user',
    query: {
      type: '',
      entityId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  deleteAdminRules: {
    url: '/admin/rules/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    query: {
      type: '',
      entityId: ''
    },
    get api() {
      return `${this.url + this.id}${generateQuery(this.query)}`;
    }
  },
  approveProductApi: {
    url: '/admin/products/approve/',
    method: 'post',
    baseURL: 'user',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  rejectProductApi: {
    url: '/admin/products/reject/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  onRevertToInprogresApi: {
    url: '/admin/products/status/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  }
};

export const manageRuleMasterViewApi = {
  getRuleMasterListApi: {
    url: '/rule-master',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postAddRuleMappingApi: {
    url: '/rule-master',
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return this.url;
    }
  },
  postAddMappingApi: {
    url: '/rule-master/mapping',
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return this.url;
    }
  }
};

export const manageRequestParamMasterViewApi = {
  getRequestParamMasterListApi: {
    url: '/rule-master/request-param-master-list',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postAddRequestParamMappingApi: {
    url: '/rule-master/request-param-master',
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return this.url;
    }
  }
};

export const fieldMasterSetupViewApi = {
  getfieldMasterSetupViewListApi: {
    url: '/admin/field-master',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postAddFieldMasterMappingApi: {
    url: '/admin/field-master',
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return this.url;
    }
  },
  postLogoutApi: {
    url: '/auth/logout',
    cancelToast: false,
    method: 'post',
    baseURL: 'user',
    get api() {
      return this.url;
    }
  }
};

export const powerBiInsightsApi = {
  getInsightsReportsListApi: {
    url: '/insights/reports-master',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      page: 1,
      take: 100,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getInsightsEmbedTokenApi: {
    url: '/insights/embed-token',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      reportId: '',
      page: 1,
      take: 100,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const managePincodeApi = {
  getManageProductApi: {
    url: '/admin/pincode',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      pincode: '',
      districtId: '',
      stateId: '',
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getManageProductRepaymentModeMappingApi: {
    url: '/admin/products/repaymentMode/details',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postProductRepaymentModeMappingRules: {
    url: '/admin/products/repaymentMode',
    cancelToast: false,
    method: 'post',
    baseURL: 'admin',
    get api() {
      return this.url;
    }
  },
  createManageDistrictApi: {
    url: '/admin/district',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      stateId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createManageStateApi: {
    url: '/admin/states',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      pincode: ''
      // districtId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getManageProductByIdApi: {
    url: '/admin/products/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  updateManageProductByIdApi: {
    url: '/admin/products/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  deleteManageProductByIdApi: {
    url: '/admin/products/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getAdminRules: {
    url: '/admin/rules',
    query: {
      type: '',
      entityId: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'admin',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postPincodeRules: {
    url: '/admin/pincode',
    cancelToast: false,
    method: 'post',
    baseURL: 'admin',
    get api() {
      return this.url;
    }
  },
  modifyAdminRules: {
    url: '/admin/rules',
    method: 'put',
    baseURL: 'admin',
    query: {
      type: '',
      entityId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  deleteAdminRules: {
    url: '/admin/rules/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    query: {
      type: '',
      entityId: ''
    },
    get api() {
      return `${this.url + this.id}${generateQuery(this.query)}`;
    }
  },
  approveProductApi: {
    url: '/admin/products/approve/',
    method: 'post',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  rejectProductApi: {
    url: '/admin/products/reject/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  }
};

export const multipleDigitalSignApi = {
  initiateSignDeskEStampApi: {
    api: '/sign-desk/initiate/Estamp',
    method: 'post',
    baseURL: 'testAgfinKyc'
  }
};

export const miscellaneousAssetsApi = {
  getFoldersApi: {
    url: '/documents/ops/miscellaneous/folders',
    query: {
      name: '',
      page: 1,
      take: 10
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },

  getViewFileFromFolderApi: {
    url: '/documents/ops/miscellaneous/folders',
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}/${this.Id}/${this.fileName}`;
    }
  },

  deleteFileFromFolderApi: {
    url: '/documents/ops/miscellaneous',
    method: 'delete',
    baseURL: 'testAgfinKyc',
    Id: null,
    query: {
      documentName: ''
    },
    get api() {
      return `${this.url}/${this.Id}${generateQuery(this.query)}`;
    }
  },

  createFolderApi: {
    url: '/documents/ops/miscellaneous',
    method: 'post',
    baseURL: 'testAgfinKyc',
    multipart: true,
    get api() {
      return this.url;
    }
  },

  uploadFileToFolderApi: {
    url: '/documents/ops/miscellaneous',
    method: 'post',
    baseURL: 'testAgfinKyc',
    multipart: true,
    get api() {
      return `${this.url}/${this.Id}`;
    }
  }
};

export const manageLegalityDocumentApi = {
  getDashboardDocumentsApi: {
    url: '/documents',
    query: {
      name: '',
      page: 1,
      take: 10,
      phone: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getViewDocumentsByIDApi: {
    url: '/documents',
    cancelToast: false,
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}/${this.documentId}`;
    }
  },
  getSignDeskDocumentsApi: {
    url: '/documents/signdesk',
    query: {
      name: '',
      page: 1,
      take: 10
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getViewSignDeskDocumentsByIDApi: {
    url: '/documents/signdesk',
    cancelToast: false,
    method: 'get',
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}/${this.documentId}`;
    }
  },
  uploadDocument: {
    api: '/documents/ops/miscellaneous',
    method: 'post',
    baseURL: 'testAgfinKyc',
    multipart: true
  },
  uploadLegalityDocumentApi: {
    api: '/admin/partner-recommendation/upload-document',
    method: 'post',
    baseURL: 'user',
    multipart: true
  }
};

export const ndcApi = {
  getTokenApi: {
    url: '/platform-setup/token',
    method: 'get',
    baseURL: 'admin',
    query: {
      serviceName: 'Lms'
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getCustomerInfoByIDApi: {
    url: '/findCustomerLoanAccounts',
    method: 'get',
    baseURL: 'lms',
    query: {
      customerId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getAccountInfoByIDApi: {
    url: '/findLoanInfo',
    method: 'get',
    baseURL: 'lms',
    query: {
      accountId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const batchDisbursementApi = {
  getPartnerApi: {
    url: '/bulk-disbursement/partners',
    method: 'get',
    baseURL: 'lms',
    get api() {
      return this.url;
    }
  },
  uploadFileApi: {
    url: '/bulk-disbursement/internal',
    query: {
      partnerId: ''
    },
    method: 'post',
    baseURL: 'lms',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getFilesApi: {
    url: '/bulk-disbursement/files',
    query: {
      partnerId: '',
      page: 1,
      take: 10
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'lms',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getDisbursementDetailsApi: {
    url: '/bulk-disbursement/grouped',
    query: {
      partnerId: '',
      fileId: '',
      page: 1,
      take: 10
    },
    method: 'get',
    baseURL: 'lms',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getIneligibleDisbursementDetailsApi: {
    url: '/bulk-disbursement/ineligible/requests',
    query: {
      partnerId: '',
      fileId: '',
      page: 1,
      take: 10
    },
    method: 'get',
    baseURL: 'lms',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  approveDisbursementApi: {
    url: '/bulk-disbursement/approve/business-ops',
    method: 'post',
    baseURL: 'lms',
    get api() {
      return this.url;
    }
  },
  getCreditDisbursementDetailsApi: {
    url: '/bulk-disbursement/grouped/credit-ops',
    query: {
      partnerId: '',
      fileId: '',
      page: 1,
      take: 10
    },
    id: null,
    method: 'get',
    baseURL: 'lms',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  approveDisbursementCreditApi: {
    url: '/bulk-disbursement/approve/credit-ops',
    method: 'post',
    baseURL: 'lms',
    get api() {
      return this.url;
    }
  },
  getDisbursementStatusApi: {
    url: '/bulk-disbursement/disbursement-status/',
    id: null,
    method: 'get',
    baseURL: 'lms',
    get api() {
      return `${this.url}${this.id}`;
    }
  },
  getFolderListApi: {
    url: '/documents/ops/miscellaneous/folder/',
    method: 'get',
    folderName: null,
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}${this.folderName}`;
    }
  },
  getViewFileFromFolderApi: {
    url: '/documents/ops/miscellaneous/folders',
    method: 'get',
    folderId: null,
    fileName: null,
    baseURL: 'testAgfinKyc',
    get api() {
      return `${this.url}/${this.folderId}/${this.fileName}`;
    }
  }
};

export const manageUserApi = {
  createManageUsersApi: {
    api: '/admin/users',
    baseURL: 'admin',
    method: 'post'
  },
  getManageUserApi: {
    url: '/admin/users',
    query: {
      partnerId: '',
      branchId: '',
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'admin',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getPartnerMetricsApi: {
    url: '/metrics/partners',
    query: {
      // metricType: '',
      partnerId: '',
      branchId: '',
      page: 1,
      take: 10,
      order: '',
      partnerName: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMandateTransactionsApi: {
    url: '/master-data/mandateTransactions',
    query: {
      memberId: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postMandateTransactionsApi: {
    api: '/v2/mandate/updateMandateTransaction',
    cancelToast: false,
    method: 'post',
    baseURL: 'kycMicroservicesV2'
  },
  getBusinessMetricsApi: {
    url: '/metrics/business',
    query: {
      metricType: '',
      partnerId: '',
      branchId: '',
      // page: 1,
      // take: 10,
      order: '',
      partnerName: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getPartnerDetailMetricsApi: {
    url: '/metrics/business',
    query: {
      partnerId: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getFarmerListByPartnerIdApi: {
    url: '/master-data/applications',
    query: {
      partnerId: '',
      page: 1,
      take: 10,
      order: '',
      applicantMobileNumber: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMasterDataUserProfileApi: {
    url: '/master-data/userProfile',
    query: {
      memberId: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMasterDataKycDetailsApi: {
    url: '/master-data/kycDetails',
    query: {
      memberId: '',
      userType: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMasterDataDisbursementDetailsApi: {
    url: '/master-data/disbursementDetails',
    query: {
      memberId: ''
      // userType: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMasterDataAuditDetailsApi: {
    url: '/master-data/auditDetails',
    query: { memberId: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getMasterDataLoanDetailsApi: {
    url: '/master-data/loanDetails',
    query: { memberId: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // getFieldStaffDetailsAct
  getFieldStaffDetailsApi: {
    url: '/master-data/fieldStaffDetails',
    query: { memberId: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // /api/master-data/esignDetails?memberId=5062&userType=applicant'
  getesignDetailsApi: {
    url: '/master-data/esignDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // /loanSnapshotDetails?memberId=5272&userType=applicant
  getloanSnapshotDetailsApi: {
    url: '/master-data/loanSnapshotDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // /api/master-data/preDisbursementDetails?memberId=4911&userType=applicant'
  getpreDisbursementDetailsApi: {
    url: '/master-data/preDisbursementDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // api/master-data/documentDetails?memberId=4115&userType=applicant
  getdocumentDetailsApi: {
    url: '/master-data/documentDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // api/master-data/supplierDetails?memberId=4115&userType=applicant'
  getsupplierDetailsApi: {
    url: '/master-data/supplierDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // api/master-data/mandateDetails?memberId=5272&memberType=applicant
  getMandateDetailsApi: {
    url: '/master-data/mandateDetails',
    query: { memberId: '', memberType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // /api/master-data/highmarkDetails?memberMobileNumber=9122966148
  getHighmarkDetailsApi: {
    url: '/master-data/highmarkDetails',
    query: { memberMobileNumber: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getKycRuleListApi: {
    url: '/kycapi/kyc-info',
    query: { mobile: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCADV2',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  // /api/master-data/dedupeDetails?memberId=5256&userType=applicant' \
  getDedupeDetailsApi: {
    url: '/master-data/dedupeDetails',
    query: { memberId: '', userType: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getManageUsersByIdApi: {
    url: '/admin/users/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  updateManageUserByIdApi: {
    url: '/admin/users/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  deleteManageUserByIdApi: {
    url: '/admin/users/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  activeInactiveUser: {
    url: '/admin/users/status/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  createPartnerApi: {
    api: '/admin/users/partner',
    baseURL: 'admin',
    method: 'post'
  },
  createNewRoleApi: {
    api: '/admin/create-user',
    baseURL: 'admin',
    method: 'post'
  },
  resetPasswordApiCall: {
    url: '/admin/users/reset-password/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  forceResetAllPasswordsApi: {
    api: '/admin/force-reset-password',
    baseURL: 'admin',
    method: 'post'
  },
  forceResetUserPasswordApi: {
    url: '/admin/force-reset-password/',
    method: 'post',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getDeviationDetailsApi: {
    url: '/deviation-details',
    query: { memberId: '', memberMobileNumber: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  postProcessDeviationApi: {
    api: '/process-deviation',
    baseURL: 'manageCAD',
    method: 'post'
  },
  getEnableApproveLoanApi: {
    url: '/enable-approve-loan',
    query: { memberId: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  cadApproveLoanApi: {
    url: '/approve-loan',
    method: 'post',
    baseURL: 'manageCAD',
    multipart: true,
    get api() {
      return this.url;
    }
  },
  postCadRunBreApi: {
    api: '/cad/run-bre',
    baseURL: 'manageCAD',
    method: 'post'
  },
  getUpdateBreRulesApi: {
    url: '/master-data/bre-rules',
    query: { mobile: '' },
    cancelToast: false,
    method: 'get',
    baseURL: 'manageCAD',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const commonApi = {
  getStateApi: {
    api: '/admin/states',
    method: 'get',
    baseURL: 'user',
    cancelToast: false
  }
};

export const viewPartnerListApi = {
  getViewPartnerList: {
    url: '/admin/partners',
    method: 'get',
    baseURL: 'admin',
    id: null,
    query: {
      search: '',
      productId: '',
      pan: '',
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    get api() {
      if (this.id) {
        return `${this.url}/${this.id}`;
      }
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createProductPartnerSetup: {
    api: '/admin/partners/product-partner-mapping',
    baseURL: 'admin',
    method: 'post'
  },
  getProductPartnerSetupList: {
    url: '/admin/partners/product-partner-mapping/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  getPartnerProductListById: {
    url: '/admin/partners/list-product-partner',
    baseURL: 'admin',
    method: 'get',
    query: {
      partnerId: null,
      productId: null,
      arn: '',
      pan: ''
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  updateProductPartnerSetup: {
    url: '/admin/partners/product-partner-mapping/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getFieldListById: {
    url: '/admin/addFields',
    baseURL: 'admin',
    method: 'get',
    query: {
      productPartnerMappingId: null
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  addFieldsList: {
    api: '/admin/addFields',
    baseURL: 'admin',
    method: 'post'
  },
  approveProductApi: {
    url: '/admin/partners/approve/',
    method: 'post',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  rejectProductApi: {
    url: '/admin/partners/reject/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  productInprogress: {
    url: '/admin/adminPartners/status/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getCommonPartnersList: {
    url: '/public/partners',
    method: 'get',
    baseURL: 'admin',
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  uploadPdfFilesApi: {
    api: '/admin/upload-document/',
    method: 'post',
    baseURL: 'admin'
  }
};

export const branchApi = {
  getBranchesList: {
    url: '/admin/branches',
    baseURL: 'admin',
    method: 'get',
    query: {
      partnerId: null,
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createBranch: {
    api: '/admin/branches',
    baseURL: 'admin',
    method: 'post'
  },
  updateBranches: {
    url: '/admin/branches/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  }
};

export const addSupplierListApi = {
  getAddSupplierList: {
    url: '/admin/suppliers',
    baseURL: 'admin',
    method: 'get',
    query: {
      partnerId: null,
      name: '',
      state: '',
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const suppliersApi = {
  getSuppliersList: {
    api: '/admin/suppliers',
    baseURL: 'admin',
    method: 'get',
    cancelToast: false
  },
  createSupplier: {
    api: '/admin/suppliers',
    baseURL: 'admin',
    method: 'post'
  },
  updateSupplier: {
    url: '/admin/suppliers/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getSupplier: {
    url: '/admin/suppliers/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  deleteSupplier: {
    url: '/admin/suppliers/',
    baseURL: 'admin',
    method: 'delete',
    id: null,
    get api() {
      return this.url + this.id;
    }
  }
};

export const supplierMappingApi = {
  getMappedSupplier: {
    url: '/admin/suppliers/product-partner-supplier-list',
    baseURL: 'admin',
    method: 'get',
    query: {
      partnerId: null,
      productId: null
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createProductPartnerMapping: {
    api: '/admin/suppliers/product-partner-mapping',
    baseURL: 'admin',
    method: 'post'
  },
  deleteProductPartnerMapping: {
    url: '/admin/suppliers/product-partner-mapping/',
    method: 'delete',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      if (this.id) {
        return this.url + this.id;
      }
      return this.url;
    }
  }
};

export const viewPartnerDetailsApi = {
  getViewPartnerDetail: {
    url: '/admin/partners/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      if (this.id) {
        return this.url + this.id;
      }
      return this.url;
    }
  }
};

export const addressList = {
  getAddressList: {
    api: '/admin/states',
    baseURL: 'user',
    method: 'get',
    cancelToast: false
  }
};

export const lookupApi = {
  getLookupData: {
    url: '/admin/lookups',
    method: 'get',
    baseURL: 'user',
    cancelToast: false,
    query: {
      type: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const reportApi = {
  downloadReport: {
    url: '/admin/downloads/reportDetails',
    method: 'post',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      emailId: '',
      fromDate: '',
      toDate: '',
      productId: '',
      partnerId: '',
      applicationStatus: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const partnerRecommendationApi = {
  getRecommendationList: {
    api: '/admin/loan-application/memberDetails',
    method: 'post',
    baseURL: 'admin',
    cancelToast: false
  },
  approveRejectRecommendation: {
    api: '/admin/loan-application',
    baseURL: 'admin',
    method: 'post'
  },
  approveRejectNachRecommendation: {
    api: '/admin/mandates/postpone',
    baseURL: 'admin',
    method: 'post'
  },
  postUpdateNachApi: {
    url: '/admin/mandates/capture',
    cancelToast: false,
    method: 'post',
    baseURL: 'admin',
    get api() {
      return this.url;
    }
  },
  getProductsList: {
    url: '/admin/loan-application/productList',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      partnerId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getRepaymentSchedule: {
    url: '/admin/loan-application/repaymentSchedule',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      accountId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getViewLoanDocumentApi: {
    url: '/admin/loan-application/document',
    method: 'get',
    baseURL: 'admin',
    query: {
      mobile: ''
    },
    cancelToast: false,
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  uploadDocument: {
    api: '/admin/partner-recommendation/upload-document',
    method: 'post',
    baseURL: 'admin',
    multipart: true
  }
};

export const adminControlPanelApi = {
  getApplicationDetails: {
    url: '/admin/getApplicationDetails',
    method: 'post',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      emailId: '',
      fromDate: '',
      toDate: '',
      productId: '',
      partnerId: '',
      applicationStatus: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  deleteApplication: {
    url: '/admin/deleteApplication',
    method: 'post',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      emailId: '',
      fromDate: '',
      toDate: '',
      productId: '',
      partnerId: '',
      applicationStatus: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const healthCheckApi = {
  gethealthCheckList: {
    url: '/health/live',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  gethealthCheckByName: {
    url: '/health/history/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    query: {
      serviceName: '',
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const cbboApi = {
  getCBBOList: {
    url: '/admin/cbbo',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      name: '',
      page: 1,
      take: 10,
      order: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  createCBBO: {
    api: '/admin/cbbo',
    baseURL: 'admin',
    method: 'post'
  },
  getCBBOById: {
    url: '/admin/cbbo/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  updateCBBOById: {
    url: '/admin/cbbo/',
    method: 'put',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  getFPOList: {
    url: '/admin/cbbo/partner/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  }
};

export const creditPdReportApi = {
  getCreditPdReportApi: {
    url: '/al/v1/credit-pd-report',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    query: {
      mobile: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  saveCreditPdReportApi: {
    api: '/al/v1/submit/credit-pd-report',
    method: 'post',
    baseURL: 'API_GATEWAY'
  }
};

export const cadApi = {
  getMemberDetails: {
    api: '/admin/cad-management/memberDetails',
    method: 'post',
    baseURL: 'admin',
    cancelToast: false
  }
};

export const caliDetailsApi = {
  getInsuranceApi: {
    url: '/insurance/payment-logs',
    method: 'get',
    baseURL: 'manageCAD',
    cancelToast: false,
    query: {
      toDate: '',
      fromDate: '',
      partnerId: '',
      status: '',
      mobile: '',
      page: 1,
      take: 10,
      order: 'ASC'
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getInsuranceByIDApi: {
    url: '/insurance',
    method: 'get',
    baseURL: 'manageCAD',
    cancelToast: false,
    query: {
      insurancePaymentId: '',
      page: 1,
      take: 10,
      order: 'ASC'
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getInsuranceDocumentApi: {
    url: '/insurance/document',
    method: 'get',
    baseURL: 'testAgfinKyc',
    cancelToast: false,
    query: {
      insuranceId: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  handleDecisionApi: {
    api: '/insurance',
    method: 'patch',
    baseURL: 'manageCAD',
    cancelToast: false
  },
  handleUpdatePaymentApi: {
    api: '/insurance/update-payment',
    method: 'patch',
    baseURL: 'manageCAD',
    cancelToast: false
  },
  handleUpdateNomineeApi: {
    api: '/insurance/update-nominee',
    method: 'patch',
    baseURL: 'manageCAD',
    cancelToast: false
  },
  handleOnboardInsuranceApi: {
    api: '/insurance/onboard-insurance',
    method: 'post',
    baseURL: 'manageCAD',
    cancelToast: false
  }
};

export const requestsApi = {
  getMemberDetails: {
    url: '/admin/service-desk/',
    method: 'get',
    baseURL: 'admin',
    id: null,
    cancelToast: false,
    get api() {
      return this.url + this.id;
    }
  },
  createRequest: {
    api: '/admin/service-desk/createNewRequest',
    baseURL: 'admin',
    method: 'post'
  },
  getRequestsList: {
    url: '/admin/service-desk',
    query: {
      partnerId: '',
      requestType: '',
      memberMobileNumber: '',
      status: '',
      page: 1,
      take: 10,
      order: ''
    },
    cancelToast: false,
    method: 'get',
    baseURL: 'admin',
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  updateMemberStatus: {
    url: '/admin/service-desk/',
    method: 'patch',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  },
  approveRejectRequest: {
    url: '/admin/service-desk/serviceRequestStatus/',
    method: 'patch',
    baseURL: 'admin',
    id: null,
    get api() {
      return this.url + this.id;
    }
  }
};

export const userLogsApi = {
  getDeviceAuthLogsApi: {
    url: '/admin/user/user-auth-logs',
    method: 'get',
    baseURL: 'admin',
    cancelToast: false,
    query: {
      page: 1,
      take: 10,
      order: 'DESC'
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  }
};

export const loanSanctionDocumentsApi = {
  getDocumentsSummaryApi: {
    url: '/unnati-mobile/v1/loan/documents-summary',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    query: { mobile: '' },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  reuploadSendbackDocumentApi: {
    api: '/unnati-mobile/v1/loan/reupload-sendback-document',
    method: 'post',
    baseURL: 'API_GATEWAY'
  },
  reviewDocumentsApi: {
    api: '/unnati-mobile/v1/loan/review-documents',
    method: 'post',
    baseURL: 'API_GATEWAY'
  }
};

export const breExecutionsApi = {
  getBreExecutionGroupsApi: {
    url: '/bre/v1/rule-orchestration/partner/executions/groups',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    query: {
      take: 10,
      page: 1,
      from: '',
      to: ''
    },
    get api() {
      return `${this.url}${generateQuery(this.query)}`;
    }
  },
  getBreExecutionGroupDetailApi: {
    url: '/bre/v1/rule-orchestration/partner/executions/groups',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    groupId: '',
    get api() {
      return `${this.url}/${this.groupId}`;
    }
  },
  getBreExecutionDetailApi: {
    url: '/bre/v1/rule-orchestration/partner/executions',
    method: 'get',
    baseURL: 'API_GATEWAY',
    cancelToast: false,
    idempotencyKey: '',
    get api() {
      return `${this.url}/${this.idempotencyKey}`;
    }
  }
};
